import { useState } from "react";
import emailjs from "emailjs-com";

export default function Contact({ bgColor }) {
  const [errors, setErrors] = useState({});
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const successMessage =
    "Gracias por tu mensaje. Nos pondremos en contacto a la brevedad.";

  const handleValidation = (e, values) => {
    e.preventDefault();
    const form = e.target;
    const newErrors = {};

    const inputs = form.querySelectorAll("input, textarea");
    inputs.forEach((input) => {
      if (!input.validity.valid) {
        switch (input.type) {
          case "email":
            newErrors[input.name] = "Ingresa un correo electrónico válido.";
            break;
          default:
            newErrors[input.name] = "Campo requerido.";
        }
      }
    });

    if (Object.keys(newErrors).length === 0) {
      // Form is valid, you can submit it here or do something else
      sendEmail(values);
    } else {
      setErrors(newErrors);
    }
  };

  const sendEmail = (values) => {
    const formData = {
      to_name: values.name,
      from_name: values.email,
      reply_to: values.phone,
      message: {
        colegio: values?.colegio,
        viajero: values?.viajero,
        // message: values.message,
        servicio: values?.servicio,
        grado: values?.grado,
        division: values?.division,
        localidad: values?.localidad,
        provincia: values?.provincia,
        medio: values?.medio,
        // Lista de Amigos
        nombreAmigo1: values?.nombreAmigo1,
        telefonoAmigo1: values?.telefonoAmigo1,
        emailAmigo1: values?.emailAmigo1,
        nombreAmigo2: values.nombreAmigo2,
        telefonoAmigo2: values?.telefonoAmigo2,
        emailAmigo2: values?.emailAmigo2,
        nombreAmigo3: values?.nombreAmigo3,
        telefonoAmigo3: values?.telefonoAmigo3,
        emailAmigo3: values?.emailAmigo3,
      },
    };
    // ESTE SERVICIO ES DE QUIERO UNA REUNION. 
    emailjs
      .send(
        "service_8cvn268",
        "template_4sy9kjo",
        formData,
        "FZJHOdNZ0PGs1dfsm",
        {
          publicKey: "FZJHOdNZ0PGs1dfsm",
        }
      )
      .then(
        (result) => {
          console.log(result.text);
          setShowSuccessMessage(true);
          // form.reset();
        },
        (error) => {
          setShowSuccessMessage(false);
          console.log(error.text);
        }
      );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const values = {
      name: form.name.value,
      viajero: form.viajero.value,
      email: form.email.value,
      phone: form.phone.value,
      colegio: form.colegio.value,
      servicio: form.servicio.value,
      grado: form.grado.value,
      division: form.division.value,
      localidad: form.localidad.value,
      provincia: form.provincia.value,
      medio: form.medio.value,
      nombreAmigo1: form.nombreAmigo1.value,
      telefonoAmigo1: form.telefonoAmigo1.value,
      emailAmigo1: form.emailAmigo1.value,
      nombreAmigo2: form.nombreAmigo2.value,
      telefonoAmigo2: form.telefonoAmigo2.value,
      emailAmigo2: form.emailAmigo2.value,
      nombreAmigo3: form.nombreAmigo3.value,
      telefonoAmigo3: form.telefonoAmigo3.value,
      emailAmigo3: form.emailAmigo3.value,
    };
    handleValidation(e, values);
  };

  return (
    <>
      <section
        id="contact"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <div className="container">
          {showSuccessMessage && (
            <div alignItems="center" justifyContent="center" padding="20px">
              <p className="text-success" style={{ fontSize: "2rem" }}>
                {successMessage}
              </p>
            </div>
          )}
          {!showSuccessMessage && (
            <div className="row">
              <div className="col-12 pb-3 message-box d-none">
                <div className="alert alert-danger"></div>
              </div>
              <div className="col-md-5">
                <div className="section-heading">
                  <h2>Quiero pedir una reunion</h2>
                </div>
                <div className="footer-address">
                  <h6>
                    <strong>Oficina Central </strong>
                  </h6>
                  <p>TUCUMAN 612, PISO 6, C.A.B.A. (C1049AAN)</p>
                  <ul>
                    <li>
                      Tel:
                      <a
                        href="https://wa.me/+5491160282658"
                        class="contact__subtitle"
                      >
                        +54 (911) 6028-2658
                      </a>
                    </li>
                    <li>
                      <span>
                        Email:{" "}
                        <a href="mailto:info@upgradeturismo.com.ar">
                          info@upgradeturismo.com.ar
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-7">
                <form
                  action="#"
                  method="POST"
                  id="contactForm"
                  className="contact-us-form"
                  noValidate
                  onSubmit={handleSubmit}
                >
                  <h5>Responderemos rápido</h5>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        {/* Agregado */}
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          placeholder="Nombre y Apellido de Padre / Madre/ Tutor"
                          required
                        />
                        {errors.name && (
                          <p className="text-danger">{errors.name}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="viajero"
                          id="viajero"
                          placeholder="Nombre y Apellido"
                          required
                        />
                        {errors.viajero && (
                          <p className="text-danger">{errors.viajero}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Selecciona un Servicio</label>
                        <select
                          id="servicio"
                          name="servicio"
                          value={selectedOption}
                          onChange={handleSelectChange}
                          className="form-control"
                          placeholder="Seleccione un servicio"
                          style={{ color: "lightgray" }}
                        >
                          <option value="primario">Upgrade Primario</option>
                          <option value="secundario">Upgrade Secundario</option>
                        </select>
                        {/* {errors.servicio && (
                          <p className="text-danger">{errors.servicio}</p>
                        )} */}
                      </div>
                    </div>
                    <div
                      className="col-sm-6 col-12"
                      // style={{ display: "flex", alignItems: "center", width:'100%' }}
                    >
                      <div className="form-group">
                        <label> </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="Ingresa email"
                          required
                        />
                        {errors.email && (
                          <p className="text-danger">{errors.email}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="phone"
                          defaultValue=""
                          className="form-control"
                          id="phone"
                          placeholder="Tu teléfono o celular"
                          required
                        />
                        {errors.phone && (
                          <p className="text-danger">{errors.phone}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="colegio"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="colegio"
                          placeholder="Nombre del colegio"
                          required
                        />
                        {errors.colegio && (
                          <p className="text-danger">{errors.colegio}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        {/*nuevo  */}
                        <input
                          type="text"
                          name="grado"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="grado"
                          placeholder="Grado"
                          required
                        />
                        {errors.grado && (
                          <p className="text-danger">{errors.grado}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        {/*nuevo  */}
                        <input
                          type="text"
                          name="division"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="division"
                          placeholder="Division"
                          required
                        />
                        {errors.division && (
                          <p className="text-danger">{errors.division}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        {/*nuevo  */}
                        <input
                          type="text"
                          name="localidad"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="localidad"
                          placeholder="Localidad"
                          required
                        />
                        {errors.localidad && (
                          <p className="text-danger">{errors.localidad}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        {/*nuevo  */}
                        <input
                          type="text"
                          name="provincia"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="provincia"
                          placeholder="Provincia"
                          required
                        />
                        {errors.provincia && (
                          <p className="text-danger">{errors.provincia}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <label>Como nos conociste?</label>
                        <select
                          id="medio"
                          name="medio"
                          value={selectedOption}
                          onChange={handleSelectChange}
                          className="form-control"
                          placeholder="Seleccione un servicio"
                          style={{ color: "lightgray" }}
                        >
                          <option value="redes">Web</option>
                          <option value="secundario">Redes</option>
                          <option value="amigo">Amigo/Conocido</option>
                          <option value="granhermano">Tv / Gran Hermano</option>
                          <option value="escapeperfecto">
                            Tv / Escape Perfecto
                          </option>
                          <option value="bienvenidosaganar">
                            Tv / Bienvenidos a Ganar
                          </option>
                          <option value="republicaZ">
                            Streaming / Republica Z
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <h5>Agrega a tus amigos y obtene increibles promociones</h5>
                  <div className="row">
                    {/* // AMIGO 1 */}
                    <div className="col-lg-4 col-sm-6 mb-lg-0 form-group">
                      <input
                        type="text"
                        name="nombreAmigo1"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="nombreAmigo1"
                        placeholder="Amigo 1"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-sm-6 mb-lg-0">
                      <input
                        type="text"
                        name="telefonoAmigo1"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="telefonoAmigo1"
                        placeholder="Telefono 1"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-sm-6 mb-lg-0">
                      <input
                        type="text"
                        name="emailAmigo1"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="emailAmigo1"
                        placeholder="Email 1"
                      />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: "10px" }}>
                    {/* // AMIGO 2 */}
                    <div className="col-lg-4 col-sm-6 mb-lg-0 form-group">
                      <input
                        type="text"
                        name="nombreAmigo2"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="nombreAmigo2"
                        placeholder="Amigo 2"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-sm-6 mb-lg-0">
                      <input
                        type="text"
                        name="telefonoAmigo2"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="telefonoAmigo2"
                        placeholder="Telefono 2"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-sm-6 mb-lg-0">
                      <input
                        type="text"
                        name="emailAmigo2"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="emailAmigo2"
                        placeholder="Email 2"
                      />
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: "10px" }}>
                    {/* // AMIGO 3 */}
                    <div className="col-lg-4 col-sm-6 mb-lg-0 form-group">
                      <input
                        type="text"
                        name="nombreAmigo3"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="nombreAmigo3"
                        placeholder="Amigo 3"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-sm-6 mb-lg-0">
                      <input
                        type="text"
                        name="telefonoAmigo3"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="telefonoAmigo3"
                        placeholder="Telefono 3"
                      />
                    </div>
                    <div className="form-group col-lg-4 col-sm-6 mb-lg-0">
                      <input
                        type="text"
                        name="emailAmigo3"
                        defaultValue=""
                        size="40"
                        className="form-control"
                        id="emailAmigo3"
                        placeholder="Email 3"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 mt-3">
                      <button
                        type="submit"
                        className="btn solid-btn"
                        id="btnContactUs"
                      >
                        Enviar mensaje
                      </button>
                    </div>
                  </div>
                </form>
                <p className="form-message"></p>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
